import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import Loader from 'components/Loader';

const Confirm = (props) => {
  const { isOpen, message, loading, onToggle, onContinue, onCancel } = props;
  return (
    <Modal centered isOpen={isOpen} toggle={onToggle}>
      <ModalBody className='m-2 p-4'>
        {loading && <Loader />}
        <h6 className='f-24 '>Confirmation!</h6>
        <p className='f-14 font-weight-400'>{message}</p>
        <div className='text-end pt-4'>
          <Button color='cancel' outline onClick={onCancel}>
            No, Cancel
          </Button>
          <Button color='primary' onClick={onContinue}>
            Proceed
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Confirm;